import React from 'react';
import { formatDate } from './formatDate';

/**
 * Date template component
 */
export const DateTemplate: React.FC<{ dateString: string }> = ({ dateString }) => {
  return <div>{formatDate(dateString)}</div>;
};

export default DateTemplate;
